export const estimationData = [
  {
    estimationId: "est-001",
    serviceId: 1,
    estimation: [
      {
        device_type: "Smartphone",
        brand_name: "Samsung",
        model_number: "Galaxy S21",
        number_of_devices: "3",
        services: "Phone battery",
        problem: "Battery drains quickly",
        cost: "26",
        day: "3",
        total_cost: "78",
      },
      {
        device_type: "Laptop",
        brand_name: "Dell",
        model_number: "Inspiron 15",
        number_of_devices: "1",
        services: "Screen replacement",
        problem: "Screen flickering",
        cost: "50",
        day: "2",
        total_cost: "50",
      },
      {
        device_type: "Tablet",
        brand_name: "Apple",
        model_number: "iPad Pro",
        number_of_devices: "2",
        services: "Charging port repaire",
        problem: "Charging port not working",
        cost: "500",
        day: "2",
        total_cost: "1000",
      },
    ],
    total_service_cost: 1128,
    discount_percent: 0,
    final_cost: 1120,
    notes: "Customer needs urgent repair",
    file: ["abc.pdf"],
  },
  {
    estimationId: "est-002",
    serviceId: 8,
    estimation: [
      {
        device_type: "Printer",
        brand_name: "Canon",
        model_number: "Pixma G3010",
        number_of_devices: "1",
        services: "Printer issue",
        problem: "Ink Leakage",
        cost: "800",
        day: "4",
        total_cost: "800",
      },
      {
        device_type: "Printer",
        brand_name: "Hp",
        model_number: "DeskJet 2131",
        number_of_devices: "1",
        services: "Printer Repaire",
        problem: "Paper Jam",
        cost: "400",
        day: "2",
        total_cost: "400",
      },
    ],
    total_service_cost: 1200,
    discount_percent: 20,
    final_cost: 960,
    notes: "Applied 20% discount",
    file: ["estimation2.pdf"],
  },
  {
    estimationId: "est-003",
    serviceId: 4,
    estimation: [
      {
        device_type: "Air Conditioner",
        brand_name: "Samsung",
        model_number: "AC5678",
        number_of_devices: "1",
        services: "Ac maintenance",
        problem: "Random restarts",
        cost: "2000",
        day: "2",
        total_cost: "2000",
      },
      {
        device_type: "Air Conditioner",
        brand_name: "Samsung",
        model_number: "AC5678",
        number_of_devices: "1",
        services: "Remote replacement",
        problem: " Remote Not working",
        cost: "100",
        day: "3",
        total_cost: "100",
      },
    ],
    total_service_cost: 2100,
    discount_percent: 10,
    final_cost: 1890,
    notes: "Discount for bulk devices",
    file: ["tab-estimation.pdf"],
  },
  {
    estimationId: "est-004",
    serviceId: 11,
    estimation: [
      {
        device_type: "Laptop",
        brand_name: "Lenovo",
        model_number: "ThinkPad X1",
        number_of_devices: 1,
        problem: "Keyboard not working",
        services: "Laptop Repair",
        cost: "2000",
        day: "2",
        total_cost: "2000",
      },
      {
        device_type: "Laptop",
        brand_name: "Asus",
        model_number: "ZenBook 14",
        number_of_devices: "1",
        services:"Touchpad Replacement",
        problem: "Touchpad malfunction",
        cost: "100",
        day: "3",
        total_cost: "100",
      },
    ],
    total_service_cost: 2100,
    discount_percent: 10,
    final_cost: 1890,
    notes: "Discount for bulk devices",
    file: ["tab-estimation.pdf"],
  },
  {
    estimationId: "est-005",
    serviceId: 3,
    estimation: [
      {
        device_type: "Printer",
        brand_name: "HP",
        model_number: "LaserJet 1020",
        number_of_devices: 4,
        problem: "Paper getting jammed",
        services: "Printer Issue",
        cost: "2000",
        day: "2",
        total_cost: "2000",
      },
      {
        device_type: "Printer",
        brand_name: "Canon",
        model_number: "PIXMA G3010",
        number_of_devices: "1",
        services:"Printer Issue",
        problem: "Paper getting jammed",
        cost: "100",
        day: "3",
        total_cost: "100",
      },
    ],
    total_service_cost: 2100,
    discount_percent: 10,
    final_cost: 1890,
    notes: "Discount for bulk devices",
    file: ["tab-estimation.pdf"],
  },
  {
    estimationId: "est-006",
    serviceId: 6,
    estimation: [
      {
        device_type: "Laptop",
        brand_name: "HP",
        model_number: "Pavilion 15",
        number_of_devices: 1,
        problem: "Overheating issue",
        services: "Laptop Repair",
        cost: "2000",
        day: "2",
        total_cost: "2000",
      },
      {
        device_type: "Laptop",
        brand_name: "Dell",
        model_number: "XPS 13",
        number_of_devices: "1",
        services:"Keyboard Replacement",
        problem: "Keyboard keys not working",
        cost: "200",
        day: "3",
        total_cost: "200",
      },
    ],
    total_service_cost: 2200,
    discount_percent: 10,
    final_cost: 1900,
    notes: "Discount for bulk devices",
    file: ["tab-estimation.pdf"],
  },
  {
    estimationId: "est-007",
    serviceId: 9,
    estimation: [
      {
        device_type: "Printer",
        brand_name: "HP",
        model_number: "LaserJet 1020",
        number_of_devices: 4,
        problem: "Paper getting jammed",
        services: "Printer Issue",
        cost: "2000",
        day: "2",
        total_cost: "2000",
      },
      {
        device_type: "Printer",
        brand_name: "Canon",
        model_number: "PIXMA G3010",
        number_of_devices: "1",
        services:"Printer Issue",
        problem: "Paper getting jammed",
        cost: "100",
        day: "3",
        total_cost: "100",
      },
    ],
    total_service_cost: 2100,
    discount_percent: 10,
    final_cost: 1890,
    notes: "Discount for bulk devices",
    file: ["tab-estimation.pdf"],
  },
];
